/* ========================================
   DC BUNDLE IMPRESII — NUCLEU PUR (T0)
   Spec: api-mobexpert/docs/lp-masurare-impresii-bundle_v2.md (§3, §4)

   Aici e DOAR logica: mașina de stări per card, deduplicarea, coada și
   loturile. Fără DOM, fără rețea, fără timere globale, fără storage.
   Adaptorul DOM (IntersectionObserver, geometrie carusel, clickuri) și
   transportul (fetch keepalive / sendBeacon) se conectează din afară.

   DE CE ceas/scheduler injectate: testele rulează în node cu ceas fals,
   iar pragul de 1000 ms trebuie verificat determinist (999 ms ≠ impresie).
=========================================== */

(function (root, factory) {
  var core = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = core;
  } else {
    root.DcBundleImpresii = root.DcBundleImpresii || {};
    root.DcBundleImpresii.core = core;
  }
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var MAX_BYTES = 8192;   // limita corpului în API (§4)
  var MAX_EVENTS = 40;    // limita per lot în API (§4)

  /* ========================================
     HELPERS
  =========================================== */

  // Lungime în bytes UTF-8 (node + browser). DE CE nu .length: diacriticele
  // și alte caractere non-ASCII ocupă 2+ bytes, iar limita API e în bytes.
  function byteLength(str) {
    if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str).length;
    return unescape(encodeURIComponent(str)).length;
  }

  function defaultUuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    // Fallback minimal (browsere vechi): suficient pentru batch_id, serverul validează.
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function str(v) {
    return v === null || v === undefined ? null : String(v);
  }

  /* ========================================
     PAYLOAD (§4)
  =========================================== */

  function buildPayload(batch, meta) {
    meta = meta || {};
    return JSON.stringify({
      v: 2,
      batch_id: String(batch.batch_id),
      pv: String(batch.pv),
      produs_id: str(meta.produs_id),
      sablon: meta.sablon || "product",
      context: meta.context || {},
      evenimente: batch.evenimente
    });
  }

  /* ========================================
     TRACKER
  =========================================== */

  function createTracker(opts) {
    opts = opts || {};
    if (!opts.pv) throw new Error("dc_bundle_impresii: pv lipsă");
    var pv = String(opts.pv);
    var now = opts.now;
    var setTimer = opts.setTimer;
    var clearTimer = opts.clearTimer;
    var uuid = opts.uuid || defaultUuid;
    var pragMs = opts.pragMs != null ? opts.pragMs : 1000;
    var pragArie = opts.pragArie != null ? opts.pragArie : 0.5;

    var pageVisible = opts.pageVisible !== false;
    var cards = {};        // b → { ratio, eligibil, varianta_id, start, timer }
    var seen = {};         // event_id → true (dedup per pv, inclusiv după ack)
    var queue = [];        // evenimente neluate încă într-un lot
    var inFlight = null;   // { batch_id, pv, evenimente } — neconfirmat
    var counters = { emise: 0, erori_transport: 0 };

    function card(b) {
      b = String(b);
      if (!cards[b]) cards[b] = { ratio: 0, eligibil: false, varianta_id: null, start: null, timer: null };
      return cards[b];
    }

    function conditionsOk(c) {
      return pageVisible && c.eligibil && c.ratio >= pragArie;
    }

    function emit(ev) {
      if (seen[ev.event_id]) return false;
      seen[ev.event_id] = true;
      queue.push(ev);
      counters.emise++;
      return true;
    }

    // Oprește cronometrul și resetează timpul continuu.
    function stop(c) {
      if (c.timer !== null) clearTimer(c.timer);
      c.timer = null;
      c.start = null;
    }

    function schedule(b, c, delay) {
      c.timer = setTimer(function () { onTimer(b); }, delay);
    }

    function onTimer(b) {
      var c = cards[b];
      if (!c) return;
      c.timer = null;
      // DE CE reverificăm: callback-ul poate sosi după o întrerupere ratată
      // de adaptor sau mai devreme (timer imprecis) — contează doar now().
      if (!conditionsOk(c) || c.start === null) { stop(c); return; }
      var elapsed = now() - c.start;
      if (elapsed < pragMs) { schedule(b, c, Math.max(1, pragMs - elapsed)); return; }
      c.start = null;
      emit({
        event_id: "visible:" + b,
        b: b,
        t: "vazut",
        varianta_id: str(c.varianta_id), // varianta de ACUM, nu cea de la flush
        ms: Math.floor(elapsed)
      });
    }

    // Pornește / oprește cronometrul după starea curentă a cardului.
    function evaluate(b, c) {
      if (seen["visible:" + b]) { stop(c); return; }
      if (!conditionsOk(c)) { stop(c); return; }
      if (c.start === null) {
        c.start = now();
        schedule(b, c, pragMs);
      }
      // altfel: rulează deja, continuitatea se păstrează
    }

    /* ---------- intrări din adaptorul DOM ---------- */

    // ratio = fracția din aria cardului vizibilă în viewport ȘI în clipul caruselului.
    // DE CE schimbarea de variantă nu resetează aici: adaptorul semnalează
    // incompatibilitatea prin eligibil=false; dacă cardul rămâne eligibil,
    // impresia continuă și poartă varianta de la momentul emiterii.
    function update(b, s) {
      b = String(b);
      var c = card(b);
      s = s || {};
      if (s.ratio !== undefined) c.ratio = +s.ratio || 0;
      if (s.eligibil !== undefined) c.eligibil = !!s.eligibil;
      if (s.varianta_id !== undefined) c.varianta_id = s.varianta_id;
      evaluate(b, c);
    }

    function setPageVisible(v) {
      pageVisible = !!v;
      for (var b in cards) evaluate(b, cards[b]);
    }

    function remove(b) {
      b = String(b);
      if (!cards[b]) return;
      stop(cards[b]);
      delete cards[b];
    }

    // Uită starea de vizibilitate a tuturor cardurilor (ex. după refiltrare).
    // NU uită deduplicarea și coada: pv-ul e același.
    function reset() {
      for (var b in cards) stop(cards[b]);
      cards = {};
    }

    function click(b, action, varianta_id) {
      b = String(b);
      action = action || "cta";
      return emit({
        event_id: "click:" + b + ":" + action,
        b: b, t: "click", action: String(action), varianta_id: str(varianta_id)
      });
    }

    // Apelat DOAR la confirmarea reală a adăugării în coș (§3.1).
    function cos(b, instanceUuid, varianta_id) {
      if (!instanceUuid) return false;
      return emit({
        event_id: String(instanceUuid),
        b: String(b), t: "cos", varianta_id: str(varianta_id)
      });
    }

    /* ---------- coada și loturi (§3.3) ---------- */

    // Returnează lotul de trimis sau null. Cât timp un lot e neconfirmat,
    // același lot (același batch_id, aceleași evenimente) e returnat la retry.
    // meta (opțional) = { produs_id, sablon, context } — folosit ca plicul
    // real să intre în calculul de bytes.
    function takeBatch(o) {
      if (inFlight) return inFlight;
      if (!queue.length) return null;
      o = o || {};
      var maxEvents = Math.min(o.maxEvents || MAX_EVENTS, MAX_EVENTS);
      var maxBytes = Math.min(o.maxBytes || MAX_BYTES, MAX_BYTES);
      var batch = { batch_id: String(uuid()), pv: pv, evenimente: [] };
      var bytes = byteLength(buildPayload(batch, o.meta || {}));
      while (queue.length && batch.evenimente.length < maxEvents) {
        var evBytes = byteLength(JSON.stringify(queue[0])) + (batch.evenimente.length ? 1 : 0);
        // Un eveniment singur prea mare nu blochează coada: pleacă singur.
        if (batch.evenimente.length && bytes + evBytes > maxBytes) break;
        batch.evenimente.push(queue.shift());
        bytes += evBytes;
      }
      inFlight = batch;
      return batch;
    }

    // Server a confirmat (2xx): evenimentele sunt livrate.
    function ack(batchId) {
      if (!inFlight || inFlight.batch_id !== batchId) return false;
      inFlight = null;
      return true;
    }

    // Eșec: lotul rămâne în zbor, retry cu același batch_id.
    // DE CE nu numără eroarea: transportul decide ce e eroare (noteTransportError).
    function nack(batchId) {
      if (!inFlight || inFlight.batch_id !== batchId) return false;
      return true;
    }

    function noteTransportError() { counters.erori_transport++; }

    function stats() {
      return {
        emise: counters.emise,
        in_coada: queue.length,
        in_zbor: inFlight ? inFlight.evenimente.length : 0,
        erori_transport: counters.erori_transport
      };
    }

    return {
      pv: pv,
      update: update,
      setPageVisible: setPageVisible,
      remove: remove,
      reset: reset,
      click: click,
      cos: cos,
      takeBatch: takeBatch,
      ack: ack,
      nack: nack,
      hasPending: function () { return !!inFlight || queue.length > 0; },
      noteTransportError: noteTransportError,
      stats: stats
    };
  }

  /* ========================================
     ── TRANSPORT ── (T4, api-mobexpert-z6wy.14; spec §3.2, §3.3, §4)

     Ia loturi din tracker și le trimite. Fără DOM-observation, fără storage.
     Dependențele (fetch, beacon, timere, ceas, document/window) sunt
     injectabile ca testele să ruleze în node; implicit se leagă la cele
     globale DOAR dacă există.

     DECIZII:
     1. Flush normal = fetch keepalive cu răspuns verificat:
          2xx            → ack, apoi următorul lot (buclă limitată)
          400/413/alte 4xx (fără 408/429) → lot invalid, retry-ul nu ajută:
                           ack (drop) + noteTransportError
          408/429/5xx/rețea → nack (același batch_id la retry) + eroare + backoff
     2. Flush de ieșire (hidden/pagehide) = sendBeacon cu Blob text/plain
        (cerere CORS simplă, fără preflight). beacon=true NU e confirmare (§3.2):
        lotul rămâne în zbor și e retrimis cu același batch_id dacă pagina
        revine (bfcache / tab vizibil); serverul deduplică. beacon=false sau
        lipsă → fetch keepalive fire-and-forget → altfel noteTransportError.
     3. La ieșire pleacă UN singur lot: nucleul ține un singur lot în zbor
        până la ack, iar fără ack nu putem lua următorul. În practică coada
        e mică (flush la prag de 20 evenimente, lot ≤40), deci un lot
        acoperă tot. Același lot nu e re-beaconat de două ori în aceeași
        ieșire (hidden + pagehide vin de regulă împreună).
     4. Prag de lot: adaptorul apelează onEvent() după fiecare emitere din
        tracker; transportul citește stats() și face flush la ≥ pragEvenimente.
        (Nu facem polling de stats — timerul periodic rămâne doar pentru 12 s.)
     5. Un singur flush în zbor; orice excepție e înghițită (nu aruncăm în pagină).
  =========================================== */

  var TEXT_PLAIN = "text/plain;charset=UTF-8";
  var BACKOFF_BAZA_MS = 2000;
  var BACKOFF_MAX_MS = 60000;
  var MAX_LOTURI_PE_FLUSH = 5;

  function g() {
    return typeof self !== "undefined" ? self : (typeof window !== "undefined" ? window : undefined);
  }

  function defaultFetch() {
    var w = g();
    return w && typeof w.fetch === "function" ? w.fetch.bind(w) : null;
  }

  function defaultBeacon() {
    if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") return null;
    return navigator.sendBeacon.bind(navigator);
  }

  // Ce facem cu un răspuns HTTP: 'ack' | 'drop' | 'retry'.
  function classifyStatus(status) {
    if (status >= 200 && status < 300) return "ack";
    if (status === 408 || status === 429 || status >= 500) return "retry";
    if (status >= 400 && status < 500) return "drop";
    return "retry"; // 0 / 1xx / 3xx neașteptate: tratăm ca tranzitoriu
  }

  function createTransport(opts) {
    opts = opts || {};
    var tracker = opts.tracker;
    var endpoint = opts.endpoint;
    var meta = typeof opts.meta === "function" ? opts.meta : function () { return {}; };
    var fetchFn = opts.fetchFn !== undefined ? opts.fetchFn : defaultFetch();
    var beaconFn = opts.beaconFn !== undefined ? opts.beaconFn : defaultBeacon();
    var setIntervalFn = opts.setIntervalFn || (typeof setInterval !== "undefined" ? setInterval : null);
    var clearIntervalFn = opts.clearIntervalFn || (typeof clearInterval !== "undefined" ? clearInterval : null);
    var nowFn = opts.now || function () { return Date.now(); };
    var BlobCtor = opts.Blob !== undefined ? opts.Blob : (typeof Blob !== "undefined" ? Blob : null);
    var doc = opts.doc !== undefined ? opts.doc : (typeof document !== "undefined" ? document : null);
    var win = opts.win !== undefined ? opts.win : (typeof window !== "undefined" ? window : null);
    var intervalMs = opts.intervalMs != null ? opts.intervalMs : 12000;
    var pragEvenimente = opts.pragEvenimente != null ? opts.pragEvenimente : 20;

    var busy = false;          // un singur flush normal în zbor
    var esecuri = 0;           // eșecuri consecutive → backoff
    var urmatoareaIncercare = 0;
    var beaconatId = null;     // batch_id pus deja în coada beacon la ieșirea curentă
    var timerId = null;
    var pornit = false;

    function safe(fn) {
      return function () {
        try { return fn.apply(null, arguments); } catch (e) { /* nu aruncăm în pagină */ }
      };
    }

    function noteError() {
      try { tracker.noteTransportError(); } catch (e) { /* ignorat */ }
    }

    function takeBody() {
      var m = {};
      try { m = meta() || {}; } catch (e) { m = {}; }
      var batch = tracker.takeBatch({ meta: m });
      if (!batch) return null;
      return { batch: batch, body: buildPayload(batch, m) };
    }

    function marcheazaEsec() {
      esecuri++;
      urmatoareaIncercare = nowFn() + Math.min(BACKOFF_MAX_MS, BACKOFF_BAZA_MS * Math.pow(2, esecuri - 1));
    }

    function marcheazaSucces() {
      esecuri = 0;
      urmatoareaIncercare = 0;
    }

    function postFetch(body) {
      return fetchFn(endpoint, {
        method: "POST",
        body: body,
        keepalive: true,
        headers: { "Content-Type": TEXT_PLAIN },
        credentials: "omit",
        mode: "cors"
      });
    }

    // Aplică decizia pe lot. Întoarce true dacă se poate continua cu următorul lot.
    function handleStatus(batchId, status) {
      var d = classifyStatus(status);
      if (d === "ack") { tracker.ack(batchId); marcheazaSucces(); return true; }
      if (d === "drop") { tracker.ack(batchId); noteError(); return true; }
      tracker.nack(batchId); noteError(); marcheazaEsec();
      return false;
    }

    function handleNetworkError(batchId) {
      tracker.nack(batchId); noteError(); marcheazaEsec();
    }

    // Flush normal: bucla de loturi, secvențial, cu răspuns verificat.
    function flushNormal() {
      if (busy || !fetchFn) return Promise.resolve(false);
      busy = true;
      beaconatId = null; // pagina e activă: un lot beaconat se retrimite prin fetch
      var n = 0;
      function pas() {
        if (n >= MAX_LOTURI_PE_FLUSH) return Promise.resolve(true);
        var lot = takeBody();
        if (!lot) return Promise.resolve(true);
        n++;
        var id = lot.batch.batch_id;
        var p;
        try { p = Promise.resolve(postFetch(lot.body)); } catch (e) { p = Promise.reject(e); }
        return p.then(function (res) {
          var status = res && typeof res.status === "number" ? res.status : 0;
          return handleStatus(id, status) ? pas() : false;
        }, function () {
          handleNetworkError(id);
          return false;
        });
      }
      return pas().then(function (r) { busy = false; return r; }, function () { busy = false; return false; });
    }

    // Flush de ieșire: best-effort, sincron cât se poate (pagina poate muri imediat).
    function flushIesire() {
      var lot = takeBody();
      if (!lot) return false;
      var id = lot.batch.batch_id;
      if (beaconatId === id) return true; // deja în coada browserului la această ieșire
      if (beaconFn) {
        var ok = false;
        try {
          var data = BlobCtor ? new BlobCtor([lot.body], { type: TEXT_PLAIN }) : lot.body;
          ok = beaconFn(endpoint, data) === true;
        } catch (e) { ok = false; }
        if (ok) {
          // DE CE fără ack: „pus în coadă" ≠ „livrat" (§3.2). Rămâne în zbor.
          beaconatId = id;
          tracker.nack(id);
          return true;
        }
      }
      if (fetchFn) {
        try {
          Promise.resolve(postFetch(lot.body)).then(function (res) {
            try { handleStatus(id, res && typeof res.status === "number" ? res.status : 0); } catch (e) { /* ignorat */ }
          }, function () {
            try { handleNetworkError(id); } catch (e) { /* ignorat */ }
          });
          return true;
        } catch (e) { /* cade pe eroare */ }
      }
      tracker.nack(id);
      noteError();
      return false;
    }

    function flush(o) {
      try {
        if (o && o.iesire) return flushIesire();
        return flushNormal();
      } catch (e) {
        busy = false;
        return (o && o.iesire) ? false : Promise.resolve(false);
      }
    }

    function pendingCount() {
      var s = tracker.stats();
      return (s.in_coada || 0) + (s.in_zbor || 0);
    }

    function poateTrimite() {
      return !busy && nowFn() >= urmatoareaIncercare;
    }

    var tick = safe(function () {
      if (tracker.hasPending() && poateTrimite()) flushNormal();
    });

    // Apelat de adaptor după fiecare eveniment emis de tracker.
    var onEvent = safe(function () {
      if (pendingCount() >= pragEvenimente && poateTrimite()) flushNormal();
    });

    var onVisibility = safe(function () {
      if (doc && doc.visibilityState === "hidden") flushIesire();
    });

    var onPagehide = safe(function () { flushIesire(); });

    var start = safe(function () {
      if (pornit) return;
      pornit = true;
      if (setIntervalFn) timerId = setIntervalFn(tick, intervalMs);
      if (doc && doc.addEventListener) doc.addEventListener("visibilitychange", onVisibility);
      if (win && win.addEventListener) win.addEventListener("pagehide", onPagehide);
    });

    var stop = safe(function () {
      if (!pornit) return;
      pornit = false;
      if (timerId !== null && clearIntervalFn) clearIntervalFn(timerId);
      timerId = null;
      if (doc && doc.removeEventListener) doc.removeEventListener("visibilitychange", onVisibility);
      if (win && win.removeEventListener) win.removeEventListener("pagehide", onPagehide);
    });

    return {
      start: start,
      stop: stop,
      flush: flush,
      onEvent: onEvent,
      tick: tick,
      state: function () {
        return { busy: busy, esecuri: esecuri, urmatoarea_incercare: urmatoareaIncercare, pornit: pornit };
      }
    };
  }

  /* ---------- eșantionare deterministă din pv (§ setare procent) ---------- */

  // true dacă pageview-ul intră în eșantion. Pur: același pv → același rezultat.
  // Primele 8 caractere hex ale UUID-ului (aleatoare în v4) → mod 100 < procent.
  function inEsantion(pv, procent) {
    var p = +procent;
    if (!(p > 0)) return false;
    if (p >= 100) return true;
    var hex = String(pv || "").replace(/-/g, "").slice(0, 8);
    if (!/^[0-9a-fA-F]{8}$/.test(hex)) return false;
    return parseInt(hex, 16) % 100 < p;
  }

  /* ── /TRANSPORT ── */

  /* ========================================
     ── ADAPTOR DOM ── (T3, api-mobexpert-z6wy.13; spec §3.1, confirmari §2-§4)

     Leagă nucleul de pagină: cine e card, cât din el se vede, când e tab-ul
     activ, clickuri pe CTA, confirmări de coș. Nu modifică widget-ul și nu
     aruncă niciodată în pagină (fiecare handler e în try/catch).

     DECIZII:
     1. Card = `.bundle-wrapper--multi[data-bundle-id]`, ID parsat strict
        `^bundle_(\d{1,20})$`. Slide-urile de campanie GWP (fără --multi, fără
        data-bundle-id) nu intră niciodată.
     2. Eligibil = în DOM ȘI display calculat ≠ none ȘI getClientRects() nevid
        (prinde și un strămoș ascuns). `.bundle-disabled` rămâne eligibil.
     3. ratio = aria(card ∩ viewport ∩ dreptunghiul .bundle-carousel) / aria(card),
        calculat geometric. IntersectionObserver (root=null, [0, .5, 1]) e doar
        declanșator de recalcul; mai recalculăm la scroll pe carusel (rAF),
        la scroll/resize pe fereastră (rAF, doar cât un card intersectează
        viewport-ul) și la dc:bundles-refiltered.
     4. Același bundle poate apărea pe mai multe variante (același data-bundle-id,
        elemente diferite). Nucleul e indexat pe b, deci agregăm per b: cel mai
        bun element eligibil dă ratio și varianta_id. Dacă elementul „purtător"
        se schimbă (schimbare de variantă), cronometrul se resetează — impresia
        nu se moștenește de la cardul altei variante.
     5. varianta_id = card.dataset.variantId. Un card e afișat doar când varianta
        lui e cea selectată (updateVisibleBundles), deci pentru un card eligibil
        e varianta selectată la momentul evenimentului. Excepție cunoscută:
        produs fără swatch-uri → widget-ul arată toate cardurile; atunci e
        varianta căreia îi aparține cardul (tot corect semantic).
     6. Context = snapshot la boot pentru varianta selectată atunci (confirmari §1).
        eligible_initial = cardurile eligibile ale ACELEI variante la primul
        dc:bundles-refiltered (emis după /cart.js, adică după ascunderea pe stoc),
        cu fallback la boot + 4 s dacă evenimentul nu vine. Până atunci cheia
        lipsește din context (serverul acceptă chei absente). Numărăm doar
        varianta snapshot-ului ca lanțul rendered_dom ≥ eligible_initial să fie
        consistent (rendered_dom e tot per variantă).
     7. Click: listener delegat pe document, în faza de capture (îl vedem chiar
        dacă altcineva oprește propagarea), doar event.isTrusted.
     8. Coș: dc:bundle-added cu instance UUID; instanța de fallback (non-UUID)
        se aruncă — validatorul ar respinge-o oricum (confirmari §4).
  =========================================== */

  var CARD_SELECTOR = ".bundle-wrapper--multi[data-bundle-id]";
  var CAROUSEL_SELECTOR = ".bundle-carousel";
  var CONTEXT_SELECTOR = "script[data-bndl-impresii-context]";
  var VARIANT_SELECTOR = 'form[action*="/cart/add"] [name="id"], select#product-select, input[name="id"]';
  var RE_BUNDLE_ATTR = /^bundle_(\d{1,20})$/;
  var RE_DIGITS = /^[1-9][0-9]{0,19}$/;
  var RE_UUID_STRICT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var CONTEXT_KEYS = ["candidate_pre_collapse", "candidate_post_collapse", "rendered_dom"];
  var ELIGIBLE_FALLBACK_MS = 4000;

  /* ---------- helpers puri (testați în node) ---------- */

  // "bundle_123" → "123"; orice altceva → null.
  function parseBundleId(attr) {
    if (typeof attr !== "string") return null;
    var m = RE_BUNDLE_ATTR.exec(attr);
    return m ? m[1] : null;
  }

  function isUuid(s) {
    return typeof s === "string" && RE_UUID_STRICT.test(s);
  }

  // ID Shopify ca șir numeric (fără zero la început) sau null.
  function cleanId(v) {
    if (v === null || v === undefined) return null;
    var s = String(v).trim();
    return RE_DIGITS.test(s) ? s : null;
  }

  // Intersecția a două dreptunghiuri {left, top, right, bottom}; null dacă e goală.
  function intersectRects(a, b) {
    if (!a || !b) return null;
    var r = {
      left: Math.max(a.left, b.left),
      top: Math.max(a.top, b.top),
      right: Math.min(a.right, b.right),
      bottom: Math.min(a.bottom, b.bottom)
    };
    return r.right > r.left && r.bottom > r.top ? r : null;
  }

  function rectArea(r) {
    if (!r) return 0;
    var w = r.right - r.left, h = r.bottom - r.top;
    return w > 0 && h > 0 ? w * h : 0;
  }

  // Fracția din card vizibilă în viewport și în clip (clip opțional = carusel).
  function visibleRatio(cardRect, viewportRect, clipRect) {
    var total = rectArea(cardRect);
    if (!(total > 0)) return 0;
    var vis = intersectRects(cardRect, viewportRect);
    if (vis && clipRect) vis = intersectRects(vis, clipRect);
    var r = rectArea(vis) / total;
    return r > 1 ? 1 : r;
  }

  // Alege contextul variantei selectate. entries = obiecte deja parsate din
  // <script data-bndl-impresii-context>. Fără variantă selectată și cu un
  // singur context (produs cu o variantă) → acela. Altfel null.
  function selectContext(entries, variantId) {
    if (!entries || !entries.length) return null;
    var want = cleanId(variantId);
    var pick = null;
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e && want && cleanId(e.variant_id) === want) { pick = e; break; }
    }
    if (!pick && !want && entries.length === 1) pick = entries[0];
    if (!pick) return null;
    var out = { variant_id: cleanId(pick.variant_id) };
    for (var k = 0; k < CONTEXT_KEYS.length; k++) {
      var val = pick[CONTEXT_KEYS[k]];
      if (typeof val === "number" && Math.floor(val) === val && val >= 0) out[CONTEXT_KEYS[k]] = val;
    }
    return out;
  }

  // Contextul trimis în plic: doar cheile cunoscute de API, fără variant_id.
  function buildContext(snapshot, eligibleInitial) {
    var ctx = {};
    if (snapshot) {
      for (var k = 0; k < CONTEXT_KEYS.length; k++) {
        if (snapshot[CONTEXT_KEYS[k]] !== undefined) ctx[CONTEXT_KEYS[k]] = snapshot[CONTEXT_KEYS[k]];
      }
    }
    if (typeof eligibleInitial === "number") ctx.eligible_initial = eligibleInitial;
    return ctx;
  }

  // measures = [{ b, el, ratio, eligibil, varianta_id }] → { b: { el, ratio, eligibil, varianta_id } }.
  // Per b câștigă elementul eligibil cu ratio maxim; la egalitate, primul.
  function aggregateByBundle(measures) {
    var out = {};
    for (var i = 0; i < measures.length; i++) {
      var m = measures[i];
      var cur = out[m.b];
      var better = !cur ||
        (m.eligibil && !cur.eligibil) ||
        (m.eligibil === cur.eligibil && m.ratio > cur.ratio);
      if (better) out[m.b] = { el: m.el, ratio: m.ratio, eligibil: m.eligibil, varianta_id: m.varianta_id };
    }
    return out;
  }

  /* ---------- adaptorul ---------- */

  function createAdapter(o) {
    o = o || {};
    var coreApi = o.core;
    var doc = o.doc;
    var win = o.win;
    var config = o.config || {};
    var transportFactory = o.transportFactory || coreApi.createTransport;
    var nowFn = o.now || function () { return Date.now(); };
    var setT = o.setTimer || function (fn, ms) { return win.setTimeout(fn, ms); };
    var clearT = o.clearTimer || function (id) { win.clearTimeout(id); };
    if (!doc || !win || !config.endpoint) return null;
    var raf = win.requestAnimationFrame ? win.requestAnimationFrame.bind(win) : function (fn) { return setT(fn, 16); };
    if (!win.IntersectionObserver) return null;
    var pv = win.crypto && typeof win.crypto.randomUUID === "function" ? win.crypto.randomUUID() : null;
    if (!isUuid(pv)) return null;
    var esantion = config.esantion == null ? 100 : config.esantion;
    if (!coreApi.inEsantion(pv, esantion)) return null;

    var tracker, transport, io;
    var tracked = [];            // [{ el, b }]
    var trackedEls = [];         // paralel cu tracked, pentru indexOf rapid
    var bearer = {};             // b → elementul care poartă starea în nucleu
    var intersecting = [];       // elemente raportate de IO ca intersectând viewport-ul
    var rafPending = false;
    var snapshot = null;
    var eligibleInitial = null;
    var eligibleTimer = null;
    var listeners = [];
    var stopped = false;

    function safe(fn) {
      return function () {
        if (stopped) return undefined;
        try { return fn.apply(this, arguments); } catch (e) { return undefined; }
      };
    }

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      listeners.push([target, type, fn, opts]);
    }

    function notifyTransport() {
      try { if (transport) transport.onEvent(); } catch (e) { /* ignorat */ }
    }

    /* ---- geometrie și eligibilitate ---- */

    function viewportRect() {
      var de = doc.documentElement;
      var w = (de && de.clientWidth) || win.innerWidth || 0;
      var h = (de && de.clientHeight) || win.innerHeight || 0;
      return { left: 0, top: 0, right: w, bottom: h };
    }

    function isEligible(el) {
      if (!el.isConnected) return false;
      var cs = win.getComputedStyle(el);
      if (!cs || cs.display === "none") return false;
      return el.getClientRects().length > 0;
    }

    function measure(el, vp) {
      if (!isEligible(el)) return { ratio: 0, eligibil: false };
      var carousel = el.closest(CAROUSEL_SELECTOR);
      var clip = carousel ? carousel.getBoundingClientRect() : null;
      return { ratio: visibleRatio(el.getBoundingClientRect(), vp, clip), eligibil: true };
    }

    /* ---- scanare carduri ---- */

    function scan() {
      var list = doc.querySelectorAll(CARD_SELECTOR);
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (trackedEls.indexOf(el) !== -1) continue;
        var b = parseBundleId(el.getAttribute("data-bundle-id"));
        if (!b) continue;
        tracked.push({ el: el, b: b });
        trackedEls.push(el);
        io.observe(el);
      }
      // Cardurile scoase din DOM ies din urmărire.
      for (var j = tracked.length - 1; j >= 0; j--) {
        if (!tracked[j].el.isConnected) {
          try { io.unobserve(tracked[j].el); } catch (e) { /* ignorat */ }
          var gone = tracked[j].el;
          tracked.splice(j, 1);
          trackedEls.splice(j, 1);
          var k = intersecting.indexOf(gone);
          if (k !== -1) intersecting.splice(k, 1);
        }
      }
    }

    function recompute() {
      var vp = viewportRect();
      var measures = [];
      for (var i = 0; i < tracked.length; i++) {
        var t = tracked[i];
        var m = measure(t.el, vp);
        measures.push({
          b: t.b, el: t.el, ratio: m.ratio, eligibil: m.eligibil,
          varianta_id: cleanId(t.el.getAttribute("data-variant-id"))
        });
      }
      var agg = aggregateByBundle(measures);
      for (var b in agg) {
        var a = agg[b];
        if (bearer[b] && bearer[b] !== a.el && a.eligibil) {
          // Alt element (altă variantă) preia bundle-ul: întrerupem continuitatea.
          tracker.update(b, { eligibil: false });
        }
        if (a.eligibil) bearer[b] = a.el;
        tracker.update(b, { ratio: a.ratio, eligibil: a.eligibil, varianta_id: a.varianta_id });
      }
      for (var old in bearer) {
        if (!agg[old]) { tracker.remove(old); delete bearer[old]; }
      }
    }

    var recomputeSafe = safe(recompute);

    function scheduleRecompute() {
      if (rafPending) return;
      rafPending = true;
      raf(function () {
        rafPending = false;
        recomputeSafe();
      });
    }

    /* ---- eligible_initial ---- */

    function countEligibleForSnapshot() {
      var n = 0;
      var want = snapshot ? snapshot.variant_id : null;
      for (var i = 0; i < tracked.length; i++) {
        var el = tracked[i].el;
        if (want && cleanId(el.getAttribute("data-variant-id")) !== want) continue;
        if (isEligible(el)) n++;
      }
      return n;
    }

    function captureEligibleInitial() {
      if (eligibleInitial !== null) return;
      eligibleInitial = countEligibleForSnapshot();
      if (eligibleTimer !== null) { clearT(eligibleTimer); eligibleTimer = null; }
    }

    function readSnapshot() {
      var nodes = doc.querySelectorAll(CONTEXT_SELECTOR);
      var entries = [];
      for (var i = 0; i < nodes.length; i++) {
        try { entries.push(JSON.parse(nodes[i].textContent)); } catch (e) { /* ignorat */ }
      }
      var sel = doc.querySelector(VARIANT_SELECTOR);
      return selectContext(entries, sel ? sel.value : null);
    }

    function meta() {
      return {
        produs_id: config.produs_id == null ? null : String(config.produs_id),
        sablon: config.sablon || "product",
        context: buildContext(snapshot, eligibleInitial === null ? undefined : eligibleInitial)
      };
    }

    /* ---- handlere ---- */

    var onIntersect = safe(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        var k = intersecting.indexOf(el);
        if (entries[i].isIntersecting && k === -1) intersecting.push(el);
        if (!entries[i].isIntersecting && k !== -1) intersecting.splice(k, 1);
      }
      recompute();
    });

    var onScrollAny = safe(function (e) {
      var t = e && e.target;
      var isCarousel = t && t.nodeType === 1 && t.matches && t.matches(CAROUSEL_SELECTOR);
      if (isCarousel || intersecting.length) scheduleRecompute();
    });

    var onResize = safe(function () {
      if (intersecting.length) scheduleRecompute();
    });

    var onRefiltered = safe(function () {
      scan();
      recompute();
      captureEligibleInitial();
    });

    var onVisibility = safe(function () {
      tracker.setPageVisible(doc.visibilityState === "visible");
    });

    var onClick = safe(function (e) {
      if (!e || !e.isTrusted) return;
      var t = e.target;
      if (!t || typeof t.closest !== "function") return;
      var btn = t.closest(".bundle-button");
      if (!btn) return;
      var card = btn.closest(CARD_SELECTOR);
      if (!card) return;
      var b = parseBundleId(card.getAttribute("data-bundle-id"));
      if (!b) return;
      if (tracker.click(b, "cta", cleanId(card.getAttribute("data-variant-id")))) notifyTransport();
    });

    var onBundleAdded = safe(function (e) {
      var d = (e && e.detail) || {};
      var b = cleanId(d.bundleId);
      if (!b || !isUuid(d.instance)) return;
      if (tracker.cos(b, d.instance, cleanId(d.variantId))) notifyTransport();
    });

    /* ---- pornire / oprire ---- */

    function start() {
      tracker = coreApi.createTracker({
        pv: pv,
        now: nowFn,
        // Emiterea „vazut" are loc în callback-ul timerului: anunțăm transportul după.
        setTimer: function (fn, ms) { return setT(function () { try { fn(); } catch (e) { /* ignorat */ } notifyTransport(); }, ms); },
        clearTimer: clearT,
        pageVisible: doc.visibilityState === "visible"
      });
      snapshot = readSnapshot();
      io = new win.IntersectionObserver(onIntersect, { root: null, threshold: [0, 0.5, 1] });
      on(doc, "visibilitychange", onVisibility);
      on(doc, "scroll", onScrollAny, { capture: true, passive: true });
      on(win, "resize", onResize, { passive: true });
      on(doc, "dc:bundles-refiltered", onRefiltered);
      on(doc, "dc:bundle-added", onBundleAdded);
      on(doc, "click", onClick, true);
      scan();
      recompute();
      eligibleTimer = setT(safe(captureEligibleInitial), ELIGIBLE_FALLBACK_MS);
      transport = transportFactory({ tracker: tracker, endpoint: config.endpoint, meta: meta, doc: doc, win: win });
      transport.start();
    }

    function stop() {
      if (stopped) return;
      stopped = true;
      try { if (io) io.disconnect(); } catch (e) { /* ignorat */ }
      for (var i = 0; i < listeners.length; i++) {
        try { listeners[i][0].removeEventListener(listeners[i][1], listeners[i][2], listeners[i][3]); } catch (e) { /* ignorat */ }
      }
      listeners = [];
      if (eligibleTimer !== null) { try { clearT(eligibleTimer); } catch (e) { /* ignorat */ } }
      try { if (transport) transport.stop(); } catch (e) { /* ignorat */ }
    }

    try { start(); } catch (e) { stop(); return null; }

    return {
      pv: pv,
      stop: stop,
      recompute: recomputeSafe,
      debug: function () {
        return {
          pv: pv.slice(0, 8),
          stats: tracker.stats(),
          carduri: tracked.length,
          eligible_initial: eligibleInitial
        };
      },
      flush: function (x) { return transport.flush(x); }
    };
  }

  /* ── /ADAPTOR DOM ── */

  return {
    createTracker: createTracker,
    buildPayload: buildPayload,
    byteLength: byteLength,
    createTransport: createTransport,
    inEsantion: inEsantion,
    classifyStatus: classifyStatus,
    createAdapter: createAdapter,
    parseBundleId: parseBundleId,
    isUuid: isUuid,
    intersectRects: intersectRects,
    visibleRatio: visibleRatio,
    selectContext: selectContext,
    buildContext: buildContext,
    aggregateByBundle: aggregateByBundle,
    MAX_BYTES: MAX_BYTES,
    MAX_EVENTS: MAX_EVENTS
  };
});

/* ── AUTO-START (ADAPTOR DOM) ──
   Pornește doar în browser și doar dacă Liquid a emis configurația
   (settings.enable_bundle_impresii). Orice eșec rămâne aici: pagina și
   widget-ul nu trebuie să afle niciodată că măsurarea există. */
(function () {
  try {
    if (typeof window === "undefined" || !window.DcBundleImpresiiConfig) return;
    var ns = window.DcBundleImpresii;
    if (!ns || !ns.core || ns.adapter) return; // deja pornit (script inclus de două ori)
    var adapter = ns.core.createAdapter({
      core: ns.core,
      doc: document,
      win: window,
      config: window.DcBundleImpresiiConfig
    });
    if (!adapter) return;
    ns.adapter = adapter;
    // Doar pentru testare manuală în consolă.
    ns.debug = function () { return adapter.debug(); };
  } catch (e) { /* fail-soft */ }
})();
